<!-- <mat-card>
  <mat-card-title>Login</mat-card-title>
<mat-card-content>
<form [formGroup]="form" (ngSubmit)="submit()">
<p>
  <mat-form-field>
    <input type="text" matInput placeholder="Username" formControlName="username">
  </mat-form-field>
</p>

<p>
  <mat-form-field>
    <input type="password" matInput placeholder="Password" formControlName="password">
  </mat-form-field>
</p>

<p *ngIf="error" class="error">
  {{ error }}
</p>

<div class="button">
  <button type="submit" mat-button>Login</button>
</div>

</form>
</mat-card-content>
</mat-card> -->
<div class="flexbox-parent" style="margin-top: 15vh;">
  <div class="main-wrapper" layout="row" layout-fill layout-align="center center">

    <mat-card class="box">
      <mat-card-header>
        <mat-card-title>Sign In</mat-card-title>
      </mat-card-header>

      <form class="example-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-card-content>
          <mat-form-field class="example-full-width">
            <input matInput placeholder="Email" type="email" formControlName="email">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <input matInput placeholder="Password" type="password" formControlName="password">
          </mat-form-field>
        </mat-card-content>
        <button mat-stroked-button color="primary" class="btn-block">Sign-in</button>
        <br><br>
        <a href="/register" style="float: right;">Don't have an Account?, Register</a>
        <br><br>
      </form>
      <button mat-stroked-button color="accent" class="btn-block" (click)="googleSignIn()">Continue with Google</button>
    </mat-card>

  </div>
</div>
